// extracted by mini-css-extract-plugin
export default {"container":"wYARM","button":"_2Lnjw","actionsContainer":"VWr8M","center":"+qxvy","right":"EDxag","triangle":"ZfWam","actionsPadding":"OKEbr"};